import store from '@/store'
import * as api from '@/api'
import dexie from '@/utils/dexie'
import router from '@/router'

export function statusMessage(text, css, spinner) {
  store.state.statusMessage.text = text;
  store.state.statusMessage.css = css;
  store.state.statusMessage.spinner = spinner;
}

export function statusClear() {
  store.state.statusMessage.text = '';
  store.state.statusMessage.css = '';
  store.state.statusMessage.spinner = false;
}

export function debug(...params) {
  if (process.env.NODE_ENV === 'development') {
    console.log(...params);
  }  
}

export function debugMobile(...params) {
  if (process.env.NODE_ENV === 'development') {
    console.log(...params);
    let paramText = '';
    for (const param of params) {
      paramText = paramText + ' ' + param;
    }
    store.state.debugMessage = paramText + '\n' + store.state.debugMessage;
  }
}

export function timeEnd(...params) {
  if (process.env.NODE_ENV === 'development') {
    console.timeEnd(...params);
  }
}

export function arrayRemoveItem(array, value) {
  const index = array.indexOf(value);
  if (index > -1) {
    array.splice(index, 1);
  }
}

export async function refreshPlayer(membershipType, membershipId) {
  debug('refreshPlayer');
  if (!membershipType || !membershipId) {
    console.error('Refresh Error');
    return;
  }
  store.state.refreshingPlayers.push(membershipId);
  const profile = await api.profile(membershipType, membershipId, 'Profiles,ProfileProgression,CharacterProgressions,Collectibles,Records,ItemObjectives,Characters,Metrics')
    .then(res => {
      return res;
    });
  if (profile) {
    let player = {
      key: membershipType + '-' + membershipId,
      id: membershipId,
      type: membershipType,
      name: profile.profile.data.userInfo.bungieGlobalDisplayName ?? profile.profile.data.userInfo.displayName,
      profile: profile
    }
    store.commit('updatePlayer', player);
    arrayRemoveItem(store.state.refreshingPlayers, membershipId);
    return player;
  }
  
}

export async function removePlayer(key) {
  store.commit('removePlayer', key);
}

export function updatePlayerRouter() {
  let params = [];
  for (const player of store.state.players) {
    params.push(player.key);
  }
  router.push('/' + params.join('/')).catch(err => err);
}

async function readPlayer(key) {
  let player = await dexie.players.get(key);
  if (!player) {
    const [type, id] = key.split('-');
    player = await refreshPlayer(type, id);
  }
  return player;
}

function isPlayerStored(key) {
  for (const player of store.state.players) {
    if (player.key === key) {
      return true;
    }
  }
  return false;
}

export async function readPlayers() {
  store.state.players = [];
  if (router.currentRoute.params.players) {
    for (const param of router.currentRoute.params.players.split('/')) {
      const player = await readPlayer(param);
      if (player && !isPlayerStored(player.key)) {
        store.state.players.push(player);
      }
    }
  }
}